import { BaseEditViewStore } from 'core/stores';
import { NikoTemplateInvoiceNoteModalForm } from 'application/niko-patient/forms';
import { action } from "mobx";
import { NikoPatientTemplateService } from 'application/niko-patient/services';

class NikoTemplateInvoiceNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const nikoPatientTemplateService = new NikoPatientTemplateService(rootStore.application.baasic.apiClient);
        const patientTemplate = componentProps.modalParams.data.patientTemplate;
        const showTemplateChangeWarning = componentProps.modalParams.data.showTemplateChangeWarning;
        super(rootStore, {
            name: 'niko-template-invoice-note-modal',
            Form: NikoTemplateInvoiceNoteModalForm,
            id: patientTemplate.id,
            actions: () => {
                return {
                    get: async () => {
                        return patientTemplate;
                    },
                    update: async () => {
                        await nikoPatientTemplateService.updateInvoiceNote(this.patientTemplate);
                        if (showTemplateChangeWarning) {
                            showTemplateChangeWarning();
                        }
                    }
                }
            },
            FormClass: NikoTemplateInvoiceNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.patientTemplate = patientTemplate;
        this.isEditDisabled = Boolean(componentProps.modalParams.data.isEditDisabled);
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            this.patientTemplate.invoiceNote = resource.invoiceNote;
            await this.actions.update();
            this.modalParams.close();
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default NikoTemplateInvoiceNoteModalStore;
